// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"MainNav_wrapper"};